import { RootState } from 'redux/store'
import { initialState } from './app.state'

export const selectAppSidebarShow = (state: RootState) => state.appState.sideBarShow

export const selectLookupData = (state: RootState) => state.appState.lookup ?? initialState.lookup
